import { render } from "./ErrorMessage.vue?vue&type=template&id=1cde54cc"
import script from "./ErrorMessage.vue?vue&type=script&lang=js"
export * from "./ErrorMessage.vue?vue&type=script&lang=js"
script.render = render

export default script